if (!customElements.get('testimonials-slider')) {
  customElements.define(
    'testimonials-slider',
    class TestimonialsSliderComponent extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        document.addEventListener('DOMContentLoaded', () => {
          this.initSwiper();
          this.handleRenderingCardsContent();
        });
      }

      initSwiper() {
        const swiperElement = this.querySelector('.mySwiper');
        if (!swiperElement) return; // Ensure the swiper element exists

        // eslint-disable-next-line no-new, no-undef
        this.swiper = new Swiper(swiperElement, {
          slidesPerView: 4, // Default to 4 slides per view
          slidesPerGroup: 1, // Move 4 slides at a time
          spaceBetween: 12,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            dynamicBullets: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            960: {
              slidesPerView: 4,
              slidesPerGroup: 1,
            },
            0: {
              slidesPerView: 'auto',
              slidesPerGroup: 1,
            },
          },
          on: {
            // Trigger this event whenever the active slide changes
            slideChange: () => {
              this.handleCardActivation(this.swiper.activeIndex);
            },
          },
        });
      }

      handleCardActivation(activeIndex) {
        const cards = this.querySelectorAll('.testimonials-slider__card');
        const testimonialsContent = this.querySelectorAll('.testimonials-slider__rendered-content-container');

        // Remove active class from all cards and content
        cards.forEach((card) => card.classList.remove('testimonials-slider__card--active'));
        testimonialsContent.forEach((content) =>
          content.classList.remove('testimonials-slider__rendered-content-container--active')
        );

        // Add active class to the card and content corresponding to the active slide
        if (cards[activeIndex]) {
          cards[activeIndex].classList.add('testimonials-slider__card--active');
          testimonialsContent[activeIndex].classList.add('testimonials-slider__rendered-content-container--active');
        }
      }

      handleRenderingCardsContent() {
        const cards = this.querySelectorAll('.testimonials-slider__card');

        cards.forEach((card, index) => {
          card.addEventListener('click', () => {
            const currentActiveIndex = this.swiper.activeIndex;

            // Move swiper based on index comparison
            if (index > currentActiveIndex) {
              // Move to next slide
              this.swiper.slideNext();
            } else if (index < currentActiveIndex) {
              // Move to previous slide
              this.swiper.slidePrev();
            }

            // Update card and content activation
            this.handleCardActivation(index);
          });
        });
      }
    }
  );
}
